module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/200.257e756b.png";